import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../config/AppContext';
import delIcon from '../../images/del.jpg';

export default function CheckoutCart({
  addToCart,
  removeItem,
  decrementItem,
  taxAmount,
  selectedItems,
  discountAmount,
  convenienceFee,
  onClickAddNote,
  hasNote,
  onClickDiscounts,
}: any) {
  const { cartItems, subTotal, setSubtotal } = useAppContext();

  setSubtotal(
    cartItems?.reduce((accumulator: any, currentItem: any) => {
      return accumulator + currentItem.total;
    }, 0),
  );
  return (
    <div className="_right_container">
      <div className="_order_summary">
        <p>Order Summary</p>
        <button className="_order_summary_note" onClick={onClickAddNote}>
          {hasNote ? 'Edit Note' : '+ Add Note'}
        </button>
      </div>
      <div className="_items_Container">
        {(!cartItems || cartItems.length === 0) && (
          <div className="_empty_cart">
            <p>No items added yet</p>
            <span>Tap a product on the left to add it to this order.</span>
          </div>
        )}
        {cartItems &&
          cartItems.map((item: any, ind: number) => {
            return (
              <div className="_item_row" key={ind}>
                <div className="_item_details_header">
                  <div>
                    <p style={{ marginBottom: '20px' }}>{item.name}</p>
                    <div style={{ marginTop: '-10px' }}>
                      {item.subSelections?.map((selection: any) =>
                        selection?.subSelections?.map(
                          (selectedItem: any, index: number) => (
                            <p
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                margin: 0,
                                marginBottom: '10px',
                                padding: 0,
                              }}
                              key={index}
                            >
                              {selectedItem.name}
                            </p>
                          ),
                        ),
                      )}
                    </div>

                    <div></div>
                  </div>
                  <span>
                    <div>
                      <p style={{ marginRight: '-4px' }}>
                        $ {(item.productPrice * item.quantity).toFixed(2)}
                      </p>
                      <div style={{ marginTop: '-10px' }}>
                        {item.subSelections?.map((selection: any) =>
                          selection?.subSelections?.map(
                            (selectedItem: any, index: number) => (
                              <p
                                style={{
                                  fontSize: '14px',
                                  fontWeight: 'normal',
                                  margin: 0,
                                  padding: 0,
                                }}
                                key={index}
                              >
                                ${' '}
                                {(selectedItem.price * item.quantity).toFixed(
                                  2,
                                )}
                              </p>
                            ),
                          ),
                        )}
                      </div>
                    </div>
                  </span>
                </div>
                <div className="_item_buttons">
                  <button
                    className="_cart_item_add"
                    onClick={() => {
                      decrementItem(ind, item.id, item.quantity);
                    }}
                  >
                    -
                  </button>
                  <img
                    alt=""
                    className="_cart_item_delete"
                    src={delIcon}
                    onClick={() => removeItem(ind, item.id, item.quantity)}
                  />
                  <button
                    className="_cart_item_add"
                    onClick={() => {
                      let product = item;
                      product.id = item.productId;
                      addToCart(product, ind);
                    }}
                  >
                    +
                  </button>
                  <span className="_item_quantity">{item.quantity}x</span>
                </div>
              </div>
            );
          })}
      </div>
      <div className="_divider" />
      <div className="_total_container">
        <div className="_subtotal">
          <span>Subtotal</span>
          <span>$ {subTotal.toFixed(2)}</span>
        </div>
        <div className="_subtotal">
          <span>Tax</span>
          <span>$ {taxAmount.toFixed(2)}</span>
        </div>
        {convenienceFee > 0 && (
          <div className="_subtotal">
            <span>POS Charges (Applied to CC only)</span>
            <span>+ $ {convenienceFee.toFixed(2)}</span>
          </div>
        )}
        {cartItems && cartItems.length > 0 && (
          <div className="_discount_row">
            {discountAmount > 0 ? (
              <button
                className="_discount_link"
                onClick={onClickDiscounts}
              >
                Discount Applied - $ {discountAmount.toFixed(2)}
              </button>
            ) : (
              <button className="_discount_link" onClick={onClickDiscounts}>
                Add discount code
              </button>
            )}
          </div>
        )}
        <div className="_total">
          <span>Order Total</span>
          <span>
            ${' '}
            {(subTotal + taxAmount - discountAmount + convenienceFee).toFixed(
              2,
            )}
          </span>
        </div>
      </div>
    </div>
  );
}
